import React, {Component, Fragment} from "react";
import {OnSelectProps} from "react-json-view";
import * as _ from "lodash";
import Table, {TableColumn} from "./Table";
import JsonViewerCard from "./JsonViewerCard";
import {CommandBarButton} from "office-ui-fabric-react";

interface WorkloadOutputViewerProps
{
    title: string;
    jsonObject: object;
    loading?: boolean;
}

interface WorkloadOutputViewerState
{
    tabularResults?: object[];
    tableColumns: TableColumn[];
}

export default class WorkloadOutputViewer extends Component<WorkloadOutputViewerProps,WorkloadOutputViewerState>
{
    constructor(props: WorkloadOutputViewerProps) {
        super(props);

        this.state = {
            tabularResults: undefined,
            tableColumns: []
        }
    }

    private onJsonSelect = (onSelectProps: OnSelectProps) => {
        
        const assumedParentArrayPath = onSelectProps.namespace.slice(0,onSelectProps.namespace.length-1) as string[];
        const parentArray =  _.get(this.props.jsonObject,assumedParentArrayPath);

        this.setState({
            tabularResults: parentArray
        });
    }
    
    public componentDidMount() {
        
    }

    async componentDidUpdate(prevProps: Readonly<WorkloadOutputViewerProps>, prevState: WorkloadOutputViewerState): Promise<void> {
        
        if(this.state.tabularResults !== prevState.tabularResults)
        {
            const columnNames = _.reduce(this.state.tabularResults,(acc: Set<string>,item: any) => {
                Object.keys(item).forEach(propertyName => {
                    acc.add(propertyName);
                });
                return acc;
            },new Set());

            const tableColumns: TableColumn[] = Array.from(columnNames).map(columnName => {
                return {title: columnName, propertyPath: columnName,flex: 1}
            });
            
            this.setState({
                tableColumns
            });
        }
    }
    
    private downloadTablularResultsAsCsv = () => {

        if (this.state.tabularResults === undefined) {
            return;
        }

        const toCsvLine = (values: string[]) => {
            values = values.map((v) => {
                return _.includes(v,",") ? `"${v}"` : v;
            });
            return _.join(values, ",") + "\n";
        };
        
        
        const csvLines = [toCsvLine(this.state.tableColumns.map(tc => tc.title))]
        this.state.tabularResults.forEach(item => {
            csvLines.push(toCsvLine(Object.values(item)));
        });

        const csvFile = _.join(csvLines, "");

        const blobUrl = URL.createObjectURL(
            new Blob([csvFile], { type: "text/csv" })
        );

        window.open(
            blobUrl,
            "_blank",
        );
    }
    
    
    public buildDrilldownTable = (): JSX.Element | undefined =>
    {
        if(this.state.tabularResults === undefined)
        {
            return undefined;
        }
        
        return (
            <Table title={"Tabular results (preview)"} items={this.state.tabularResults} columns={this.state.tableColumns}>
                <CommandBarButton
                    iconProps={{iconName: "DownloadDocument"}}
                    text="Download as CSV (preview)"
                    onClick={this.downloadTablularResultsAsCsv}
                />
                <CommandBarButton
                    iconProps={{iconName: "Cancel"}}
                    text="Close"
                    onClick={() => this.setState({tabularResults: undefined})}
                />
            </Table>
        );
    }

    public render() {
        return (
            <Fragment>
                {this.buildDrilldownTable()}
                <JsonViewerCard title={this.props.title} extraDetail={"Click value to view tabular results (preview)"} jsonObject={this.props.jsonObject} loading={this.props.loading} onSelect={this.onJsonSelect}>
                    {this.props.children}
                </JsonViewerCard>
            </Fragment>
        );
    }
}